export default __webpack_public_path__ + "static/media/live-chat-blue.1e0832b4.svg";